import { render, staticRenderFns } from "./SBButtonGeneral.html?vue&type=template&id=e949bc64&scoped=true&"
import script from "./SBButtonGeneral.ts?vue&type=script&lang=ts&"
export * from "./SBButtonGeneral.ts?vue&type=script&lang=ts&"
import style0 from "./SBButtonGeneral.css?vue&type=style&index=0&id=e949bc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e949bc64",
  null
  
)

export default component.exports